import React, { useState, useEffect } from "react";
import { SERVE_FIRST_LOGO as serveFirstLogo } from "../constants/branding";
import "./index.css";
import { postData } from "../components/FetchServicesWithoutJwtToken";
import { useQuery } from "../webRatingNew/FrontWebLogin";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import { Rate } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";

export default function CsatFeedback() {
  const intl = useIntl();
  const [feedback, setFeedback] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [primaryColor, setPrimaryColor] = useState("#8F63AA");
  const [saveLoading, setSaveLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [ratingLocked, setRatingLocked] = useState(false);
  const [existingRating, setExistingRating] = useState(null);
  const query = useQuery();
  const helpdesk_id = query.get("helpdesk_id") ?? null;
  const rating = query.get("rating") ?? null;

  // Get the current rating value safely
  const getRatingValue = () => {
    const ratingValue = ratingLocked ? existingRating : rating;
    const parsedRating = parseInt(ratingValue);
    return isNaN(parsedRating) ? 5 : parsedRating;
  };

  const handleSendFeedback = async (feedbackData = "") => {
    try {
      if (helpdesk_id) {
        setSaveLoading(true);
        const body = {
          rating: ratingLocked ? existingRating : rating,
          helpdesk_id: helpdesk_id,
        };
        if (feedbackData) {
          body.feedback = feedbackData;
        }
        const result = await postData("help_desk/updateCustomerRating", body);
        if (!result?.success) {
          toast.error(result?.message || "Something went wrong");
        } else {
          setFeedback("");
          if (result?.success && feedback) {
            setShowSuccessMessage(true);
          }
        }
        setSaveLoading(false);
      }
    } catch (error) {
      toast.error(error?.message);
      setSaveLoading(false);
    }
  };

  const checkCustomerRatingStatus = async () => {
    const body = {
      helpdesk_id: helpdesk_id,
    };
    const result = await postData("help_desk/checkCustomerRatingStatus", body);
    setCompanyLogo(result?.data?.logoUrl || serveFirstLogo);
    setPrimaryColor(result?.data?.brandColor || "#8F63AA");
    if (result?.data?.rating_locked) {
      setRatingLocked(true);
      setExistingRating(result?.data?.helpdesk?.customer_rating?.rating);
    }
    if (result?.data?.locked) {
      setShowSuccessMessage(true);
    } else {
      setShowSuccessMessage(false);
      handleSendFeedback();
    }
  };

  useEffect(() => {
    checkCustomerRatingStatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleClosePage = () => {
    window.close();
  };

  return (
    <div className="feedback-container">
      <div className="feedback-header">
        <img
          className="feedback-logo"
          src={companyLogo ? companyLogo : serveFirstLogo}
          alt="logo"
        />
      </div>

      <div className="feedback-content">
        <div className="feedback-card">
          {!showSuccessMessage ? (
            <>
              <div className="check-icon-wrapper">
                <div className="star-rating-container">
                  <Rate
                    defaultValue={getRatingValue()}
                    max={getRatingValue()}
                    readOnly={true}
                    value={getRatingValue()}
                    size="lg"
                  />
                </div>
              </div>
              <h2 className="feedback-title">
                {intl.formatMessage({ id: "thank-you-for-your-feedback" })}
              </h2>
              <p className="feedback-subtitle">
                {intl.formatMessage({
                  id: "please-leave-any-extra-feedback-in-the-box-below",
                })}
              </p>
              <textarea
                className="feedback-textarea"
                placeholder={intl.formatMessage({
                  id: "enter-your-feedback-here",
                })}
                value={feedback}
                onChange={handleFeedbackChange}
              />
              <p className="confidential-text">
                {intl.formatMessage({ id: "all-feedback-is-confidential" })}
              </p>
              <button
                className="send-button"
                onClick={() => handleSendFeedback(feedback)}
                style={{ backgroundColor: primaryColor }}
                disabled={saveLoading || !feedback}
              >
                {saveLoading
                  ? intl.formatMessage({ id: "sending" })
                  : intl.formatMessage({ id: "send" })}
              </button>
            </>
          ) : (
            <>
              <div className="check-icon-wrapper">
                <div className="star-rating-container">
                  <Rate
                    defaultValue={getRatingValue()}
                    max={getRatingValue()}
                    readOnly={true}
                    value={getRatingValue()}
                    size="lg"
                  />
                </div>
              </div>
              <h2 className="feedback-title">
                {intl.formatMessage({ id: "thank-you-for-your-feedback" })}
              </h2>
              <p className="success-subtitle">
                {intl.formatMessage({
                  id: "your-feedback-has-been-received-thank-you",
                })}
              </p>
              <button
                className="send-button"
                onClick={handleClosePage}
                style={{ backgroundColor: primaryColor }}
              >
                {intl.formatMessage({ id: "close-page" })}
              </button>
            </>
          )}
        </div>
      </div>
      <div
        className="feedback-footer"
        style={{ backgroundColor: primaryColor }}
      >
        {intl.formatMessage({ id: "for-anything-else-please" })}{" "}
        <a href="#" className="contact-link" style={{ color: "#ffffff" }}>
          {intl.formatMessage({ id: "contact-us" })}
        </a>
      </div>
    </div>
  );
}
